<app-hero [title]="'Stellenangebote'"></app-hero>
<section id="services" class="services section">
  <div class="container section-title" data-aos="fade-up">
    <h2>Stellenangebote</h2>
    <p>Wir unterstützen Sie in diesen Bereichen.</p>
  </div><!-- End Section Title -->
  <div class="container d-flex justify-content-center flex-column">
    <div class="row gy-4">
      <div class="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="100" *ngFor="let job of jobs">
        <div class="service-item position-relative">
          <figure>
            <img [src]="job.image" alt="Unser Team" style="width:100%; height: auto;">
          </figure>
          <h3>{{job.title}}</h3>
          <p>{{sharedService.getSubText(job.text)}}</p>
          <div class="d-flex align-items-center justify-content-between">
            <a *ngIf="job" [routerLink]="['/job-details', job.id]">
              Mehr erfahren <i class="bi bi-arrow-right"></i>
            </a>
            <button *ngIf="job" 
                    (click)="navigateToApplicationComponent(job.id)" 
                    class="btn btn-primary btn-sm fw-bold mt-3">
              Jetzt bewerben
            </button>
          </div>
        </div>
      </div>
    </div>

    <button *ngIf="category" class="primary-btn" style="margin:50px auto !important; width: 200px;" routerLink="/Jobs">Alle Stellen ansehen</button>
  </div>
</section><!-- /Services Section -->
<div *ngIf="showSpinner" style="display: flex; align-items: center; justify-content: center;">
  <div class="spinner-border text-primary" role="status">
    <span class="visually-hidden">Lädt...</span>
  </div>       
</div>